/**
 * Created by nemio on 10.12.2016.
 */

import moment from 'moment';
import ar from 'moment/locale/ar';

moment.updateLocale('ar_AR', {
  calendar: {
    lastDay: '[اليوم السابق]',
    sameDay: '[اليوم]',
    nextDay: '[Tomorrow]',
    lastWeek: '[Last] dddd',
    nextWeek: '[Next] dddd',
    sameElse: '[Earlier]'
  }
});

const ar_AR = {
  yes: 'نعم',
  no: 'لا شكراً',
  no_thanks: 'No, thank you',
  loading: 'جار التحميل...',
  global_error: 'Sorry, site is unavailable due technicals reason. Please, try again later',
  email: 'البريد الالكتروني',
  password: 'كلمة المرور',
  close: 'أغلاق',
  favorites: 'المفضلة',
  search: 'البحث',
  related: 'مرتيط',
  tv: 'قنوات التلفزيون',
  movies: 'أفلام',
  tvseries: 'مسلسلات تلفزيونيه',
  on_now: 'دليل البرامج الالكتروني',
  cartoons: 'الرسوم المتحركة',
  purchases: 'Purchases',
  premiere: 'New in theaters',
  my_services: {
    my_services: 'خدماتس',
    my_rents: 'My content',
    my_subscriptions: 'My subscriptions',
    subscriptions: 'اشترك الان',
    rents: 'تأجير'
  },
  page: {
    home: 'منزل',
    epg: 'دليل البرامج الالكتروني',
    favorites: 'المفضلة',
    notifications: 'Notifications',
    records: 'تسجيل',
    purchases: 'Purchases',
    related: 'مرتيط',
    search: 'البحث',
    collection: 'Collection'
  },
  error: {
    invalid_credentials: 'التسجيل أو كلمة المرور غير صحيحة',
    invalid_credentials_description: ' ',
    blocked_subscription: 'عزيزي المشترك، الاشتراك الخاص بك غير متوفر حالياً، يرجى إضافة المال إلى حسابك الشخصي. شكرا',
    'invalid credentials': 'كلمة المرور القديمه غير صحيحه',
    'passwords mismatch': 'The passwords must match.',
    'username field empty': 'Email field should not be empty.',
    'already exist': 'This email is not available. Please choose another email address or Sign In',
    'password field empty': 'Password field should not be empty.',
    'password too short': 'The password must be at least 6 characters. When generating, you can use letters, numbers, and any special characters.',
    'invalid password reset code': 'Invalid confirmation Code',
    'invalid ack': 'Confirmation code invalid',
    'invalid pin': 'Invalid pin code'
  },
  registration: {
    texts: {
      button: 'Create account',
      title: 'شكرا لتسجيلك',
      description: 'تم ارسال البريد الالكتروني الخاص بك الرجاء الضغط على الرابط فب البريد الالكتروني لتفعيل حسابك'
    }
  },
  login: {
    login: 'البريد الالكتروني',
    login_example: 'name@domain.com',
    lost_your_password: 'فقدت كلم',
    logout: 'خروج',
    log_in: 'دخول'
  },
  forgot_password: {
    login: 'البريد الالكتروني',
    login_example: 'name@domain.com',
    lost_your_password: 'فقدت كلم',
    forgot_password: 'هل نسيت كلمة السر',
    send: "ارسال",
    recovery_password: "استعادة كلمة المرور",
    empty_field: "خانة فارغه",
    wrong_email: "رسالة الكترونية خاطئه",
    reset_password_success_message: "سوف يصلك بريد الكتروني مع رابط لاعادة تشكيل كلمة المرور",
    reset_password_error_message: "سوف يصلك بريد الكتروني مع رابط لاعادة تشكيل كلمة المرور",
  },
  profile: {
    movie: {
      bundle: 'اختيار الباقة',
      min: 'min',
      fav_add: 'اضافة الى القائمة المفضلة',
      fav_remove: 'في القائمة المفضلة',
      trailer: 'فيلم قصير',
      youtube_trailer: ' مقطورة Youtube',
      multiscreen: 'تابع على شاشة اخرى',
      related: 'مرتيط',
      share: 'مشاركة',
      select_screen: 'اختر الشاشه'
    },
    tvSeries: {
      bundle: 'اختيار الباقة',
      min: 'min',
      fav_add: 'اضافة الى القائمة المفضلة',
      fav_remove: 'في القائمة المفضلة',
      trailer: 'فيلم قصير',
      multiscreen: 'تابع على شاشة اخرى',
      related: 'مرتيط',
      share: 'مشاركة',
      select_screen: 'اختر الشاشه',
      seasons: 'مواسم',
      episodes: 'حلاقات',
      season_short: 'موسم', //S01E12
      episode_short: 'حلقة', //S01E12
    },
    channel: {
      calendar: {
        before: 'قبل',
        previously: 'سابقاً',
        now: 'الان',
        after: 'التالي',
        hereafter: 'لاحقاً',
        yesterday: 'اليوم السابق',
        yesterday_at: 'اليوم السابق',
        today: 'اليوم',
        today_at: 'اليوم',
        tomorrow: 'Tomorrow',
        tomorrow_at: 'Tomorrow at',
        last: 'Last'
      },
      epg: 'دليل البرامج الالكتروني',
      bundle: 'اختيار الباقة',
      min: 'min',
      fav_add: 'اضافة الى القائمة المفضلة',
      fav_remove: 'في القائمة المفضلة',
      record_add: 'Add record',
      record_remove: 'Delete record',
      schedule_remove: 'Cancel record',
      multiscreen: 'تابع على شاشة اخرى',
      share: 'مشاركة',
      select_screen: 'اختر الشاشه'
    },
    subscription: {
      subscription: 'الغاء العضوية',
      included: 'يتضمن',
      expires: 'Expires',
      bought: 'اشترى',
      owned: 'Owned',
      subscription_period_end: 'Next payment date',
      subscription_period_start: 'Subscription start date',
      subscription_states: {
        active: 'Active',
        trialing: 'Trial',
        unpaid: 'Waiting payment',
        '_': 'Unknown'
      },
      cancel: 'الغاء الاشتراك',
      canceled: 'الغاء',
      first_payment: 'First payment',
      details: 'Details',
      status: 'Status',
      are_you_sure: 'Are you sure',
      cancel_desc: 'You want to cancel your subscription for',
      re_subscribe: 'You can re-activate your subscription only after the end of the current period.',
      yes: 'نعم',
      no: 'لا شكراً'
    },
    packages: {
      included: 'يتضمن',
      expires: 'Expires',
      bought: 'اشترى',
      owned: 'Owned'
    },
    epg_event: {
      remind_me: 'تذكير',
      not_remind: 'عدم التذكير',
      record_add: 'Add record',
      record_remove: 'Delete record',
      schedule_remove: 'Cancel record'
    },
    notification: {
      remind_me: 'تذكير',
      not_remind: 'عدم التذكير',
    },
    npvr: {
      record_add: 'Add record',
      record_remove: 'Delete record',
      schedule_remove: 'Cancel record'
    },
    ratings: {
      rating_delimiter: '/'
    },
    persons: {
      operator: 'المشغل',
      assembly: 'جمهور',
      actor: 'ممثل',
      director: 'مخرج',
      scenario: 'النص',
      composer: 'مؤلف',
      presenter: 'مقدم',
      music_director: 'المخرج الموسيقي',
      playback_singers: 'Playback Singers',
      _: 'other'
    },
    offers: {
      type: {
        'free': 'مجاني',
        'transactional-own': 'شراء',
        'transactional-rent': 'تأجير',
        'subscription': 'Subscribe',
        'transactional-own-bundle': 'Buy in bundle',
        'transactional-rent-bundle': 'Rent in bundle',
        'subscription-bundle': 'Subscribe in bundle',
        '_': 'Other'
      },
      pay_as_you_go: 'شراء العرض',
      select_bundle: 'اختيار الباقة',
      or: 'او',
      "free_trial": "تجربة مجانية",
      "free_trial_description": "بعد التجربة سوف يتم خصم رسوم الاشتراك من حسابك",
      unit: {
        hour: 'ساعه',
        day: 'يوم',
        week: 'Week',
        month: 'شهر',
        year: 'سنة',
      }
    }
  },
  player: {
    no_signal: 'لا توجد إشارة',
    reload: 'Reload',
    youtube_connection_error: 'خطأ اتصال يوتيوب'
  },
  more_menu_items: 'المزيد',
  empty_section: 'هذا القسم فارغ',
  empty_result: 'لا نتيجة',
  epg: {
    no_data: 'لايوجد بيانات',
    now: 'الان',
    today: 'اليوم'
  },
  npvr: {
    filters: {
      status: 'Sort by recording state',
      date: 'Sort by recording date',
      alphabet: 'Sort by recording title',
      channel: 'Sort by recording channel'
    },
    status: {
      pending: 'Pending',
      scheduled: 'In schedule',
      recording: 'In progress',
      finished: 'Finished',
      failed: 'Failed',
      cancelled: 'Canceled by user'
    },
    usage: 'Usage',
    limit_desc: 'This indicates how much space you have used out of the total space available.',
    limit_desc_warning: 'You almost reached limit of recorded programs',
    limit_desc_reached: 'You have reached your nPVR recordings limit, please remove some existing recordings to free space.'
  },
  genres: 'الانواع',
  messages: {
    pin: {
      title: 'ادخل رقمك السري',
      ok: 'OK',
      cancel: 'Cancel'
    },
    notification: {
      title: 'Reminder on ',
      on_channel: 'On channel',
      is_switch_show_right_now: 'starts in 5 minutes. Switch to show right now?'
    },
    share_request: {
      title: 'Share ',
      vod: 'video',
      live: 'channel',
      you_have_received: 'You have received',
      sharing_notification: 'sharing notification. Do you want to watch?'
    },
    bookmark: {
      title: 'Continue watching?',
      continue_from: 'Continue from',
      start_over: 'Start over'
    }
  },
  settings: {
    settings: 'الاعدادات',
    tabs: {
      login: {
        title: 'دخول',
        email: 'البريد الالكتروني',
        password: "كلمة المرور",
        sign_in: 'الدخول بواسطة',
        error: 'التسجيل أو كلمة المرور غير صحيحة',
        success: 'Welcome back dear customer!'
      },
      registration: {
        title: 'تسجيل',
        email: 'البريد الالكتروني',
        password: "كلمة المرور",
        password2: 'تأكيد كلمة المرور',
        first_name: 'الاسم الاول',
        last_name: 'اسم العائلة',
        sign_up: 'تسجيل',
        success: "شكرا لتسجيلك",
        need_confirmation: "تم إرسال رسالة التسجيل إلى عنوان البريد الإلكتروني الخاص بك. يرجى فتح البريد الإلكتروني الخاص بك، وانقر على الرابط لتأكيد تسجيلك.",
      },
      registration_confirm: {
        success: "شكرا لتسجيلك كلمة الدخول و كلمة المرور يمكن استعمالهم الان على جهاز اخر يقدم هذه الخدمه"
      },
      language: {
        title: 'اللغه',
        select_language: 'اختيار اللغه:'
      },
      parental_control: {
        title: 'مراقبة الاهل',
        description: 'تفعيل الرقابة الابوية',
        on: 'تشغيل',
        off: 'ايقاف'
      },
      change_password: {
        title: 'تغير كلمة المرور',
        save: 'حفظ',
        old_password: 'كلمة المرور القديمة',
        new_password: 'كلمة المرور الجديده',
        new_password2: 'تأكيد كلمة المرور',
        success: 'كلمة المرور بنجاح تحديث'
      },
      reset_password: {
        title: 'اعادة تعيين كلمة السر',
        save: 'حفظ',
        enter_new_password: 'كلمة المرور الجديده',
        ack: 'تأكيد الكود',
        password: 'كلمة المرور الجديده',
        success: 'سوف يصلك بريد الكتروني مع رابط لاعادة تشكيل كلمة المرور'
      },
    },
  },
  toast: {
    type: {
      record: 'Record',
      favorite: 'Favorite',
      notification: 'Notification',
      purchase: 'Purchase',
      service: 'Service',
      cookies: 'Cookies',
      adblock: 'Ad block'
    },
    operation: {
      record_add_success: 'Schedule recording was successful',
      record_add_fail: 'Schedule recording failed',
      record_remove_success: 'Cancel recording was successful',
      record_remove_fail: 'Cancel recording failed',
      favorite_add_success: 'Was added successfully',
      favorite_add_fail: 'Adding failed',
      favorite_remove_success: 'Was removed successfully',
      favorite_remove_fail: 'Removing failed',
      notification_add_success: 'Was added successfully',
      notification_add_fail: 'Adding failed',
      notification_remove_success: 'Was removed successfully',
      notification_remove_fail: 'Removing failed',
      purchase_add_success: 'Operation was successfully completed',
      purchase_add_fail: 'Operation failed',
      purchase_remove_success: 'Operation was successfully completed',
      purchase_remove_fail: 'Operation failed',
      service_unstable_connection: 'Unstable connection to server',
      enable_cookies: 'Please enable cookies. ',
      disable_adblock: 'AdBlock can affect the functionality of the site. ' +
      'Please add us to Whitelist in your Ad blocker.'
    }
  }
};

export default ar_AR;



// WEBPACK FOOTER //
// ./src/locales/dics/ar_AR.js